module.exports = __webpack_public_path__ + "img/prat.a107e702.png";